module.exports = __webpack_public_path__ + "static/media/sub-table-sample-2-preview.fdc8a48c.png";